import { useState, useEffect } from "react";
import axios from "../../../services/index.service";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import TopNav from "../../../components/TopNav";
import ButtomButton from "../../../components/DocButtomButton";
import { Loading } from "../../../utils/helpers/constants";
import ErrorInputComponent from "../../../components/ErrorInputComponent";
import {
  processUserDocument,
  fetchDocumentInstructions,
} from "../../../actions/document.action";
import DropDownInput from "../../../components/DropDownInput";

export default function OfficialLetter() {
  // const history = useHistory();
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const [modalState, setModalState] = useState(false);
  const [documentFee, setDocumentFee] = useState(0);
  const [alumniFee, setAlumniFee] = useState(0);

  const {
    documentInstruction: {
      instructions,
      instructionLoading,
      processDocumentLoading,
    },
  } = useSelector(({ documentReducer }) => ({
    documentInstruction: documentReducer,
  }));

  useEffect(() => {
    dispatch(fetchDocumentInstructions("ENGLISH_WAIVER"));
    dispatch(fetchDocumentInstructions("RECOMMENDATION_LETTER"));
    getDocumentFee("ENGLISH_WAIVER", "SOFT_COPY");
  }, []);

  const getDocumentFee = (feeType, format) => {
    axios.get(`/api/services/v1/fees/type/${feeType}/${format}`).then((res) => {
      if (res?.data !== undefined) {
        if (Object.keys(res?.data).length) {
          setDocumentFee(res.data.fee);
        }
      }
    });
  };

  const validationSchema = Yup.object({
    institutionName: Yup.string().required("Institution Name is required"),
    institutionAddress: Yup.string().required(
      "Institution Address is required"
    ),
    receiverName: Yup.string().required("Receiver Name is required"),
    receiverEmail: Yup.string()
      .email("Field should contain a valid e-mail")
      .max(255)
      .required("Receiver Email is required"),
  });

  const { handleSubmit, handleChange, values, errors } = useFormik({
    initialValues: {
      institutionName: "",
      institutionAddress: "",
      receiverName: "",
      receiverEmail: "",
      documentType: "ENGLISH_WAIVER",
    },
    validationSchema,
    onSubmit(values) {
      const payload = {
        institutionName: values.institutionName,
        institutionAddress: values.institutionAddress,
        documentType: values.documentType,
        transcriptDeliveryDto : {
          receiverEmail: values.receiverEmail,
          receiverName: values.receiverName,
        }
      };
      const modalText =
        "Your request for official letter is successful. Kindly check your email.";
      dispatch(processUserDocument(payload, modalText));
    },
  });

  const buttonLoadState = processDocumentLoading === Loading.FETCHING;
  const loadState = processDocumentLoading === Loading.SUCCESS;
  const documentType = [
    { value: "ENGLISH_WAIVER", name: "English Waiver" },
    { value: "RECOMMENDATION_LETTER", name: "Recommendation Letter" },
  ];

  useEffect(() => {
    if (loadState && modalState) {
      setModal(true);
    } else {
      setModal(false);
    }
  });

  const InstructionComponent = ({ instruction }) => {
    return (
      <li>
        {instruction?.instruction}
        <span className="font-bold">
          {instruction?.costType === "ALUMNI_FEE" ? " N" + alumniFee : null}
          {instruction?.costType === "TRANSCRIPT_OFFICIAL"
            ? " N" + documentFee
            : null}
        </span>
      </li>
    );
  };

  return (
    <div className="overflow-hidden">
      <div className=" doc_processing_color h-44 px-2 pt-3">
        <TopNav />
        <div className="transcript_header">Official Letter</div>
        <div className="text-md md:w-2/3">
          Get your English Waiver or Reference Letter for your Postgraduate
          studies or Visa application sent to you.
        </div>
      </div>
      <div className="px-2 md:mx-20 mt-2 md:mt-10">
        <div>
          <p className="font-semibold text-lg">Requirements:</p>
          <>
            {instructionLoading ? (
              <div>Loading....</div>
            ) : (
              <div className="px-4">
                <ul className="space-y-1 max-w-md list-disc list-inside">
                  {instructions.map((instruction, index) => {
                    return (
                      <InstructionComponent
                        instruction={instruction}
                        key={index}
                      />
                    );
                  })}
                </ul>
              </div>
            )}
          </>
        </div>
        <div className="md:flex md:flex-column md:justify-center">
          <div className="px-0 md:w-1/2 mt-0">
            <form className="p-0">
              <div className="mt-5">
                <div className="font-bold">Institution Details</div>
                <input
                  className="mt-1 appearance-none border border-gray-400 rounded w-full pt-4 pb-4 py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-green-800"
                  id="inline-full-name"
                  type="name"
                  name="institutionName"
                  onChange={handleChange}
                  placeholder="Name of Institution"
                />
                <ErrorInputComponent error={errors.institutionName} />
                <input
                  className="mt-3 appearance-none border border-gray-400 rounded w-full pt-4 pb-4 py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-green-800"
                  id="inline-full-name"
                  type="name"
                  name="institutionAddress"
                  onChange={handleChange}
                  placeholder="Address of Institution"
                />
                <ErrorInputComponent error={errors.institutionAddress} />

                <div className="w-full mt-3">
                  <DropDownInput
                    list={documentType}
                    name="documentType"
                    handleChange={handleChange}
                    placeholder="document type"
                  />
                </div>
              </div>

              <div className="mt-5">
                <div className="font-bold">Receiver Details</div>
                <input
                  className="mt-1 appearance-none border border-gray-400 rounded w-full pt-4 pb-4 py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-green-800"
                  id="inline-full-name"
                  type="text"
                  name="receiverName"
                  onChange={handleChange}
                  placeholder="Receiver's Name"
                />
                <ErrorInputComponent error={errors.receiverName} />
                <input
                  className="mt-3 appearance-none border border-gray-400 rounded w-full pt-4 pb-4 py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-green-800"
                  id="inline-full-name"
                  type="email"
                  name="receiverEmail"
                  onChange={handleChange}
                  placeholder="Receiver's Email"
                />
                <ErrorInputComponent error={errors.receiverEmail} />
              </div>
            </form>
            <ButtomButton
              name={"Request"}
              func={handleSubmit}
              loading={buttonLoadState}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
